import React from 'react';
import {Tooltip as ReactTooltip} from 'react-tooltip';

import Icon from  '@/components/elements/icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';

import {LocationService} from "../../../../services/location.service.ts";

import '../../../../css/global/download-report-button.scss';




const DownloadReportButton = ({downloadLink, tooltipText}:{downloadLink: string, tooltipText: string}) => {
    function download() {
        LocationService.setHref(downloadLink);
    }

    return (
        <>
        <button className="download-report-button" onClick={download} data-tooltip-id={`download-report-button`} data-tooltip-content={tooltipText} aria-label='Download Report'>
            <Icon iconName={IconLibrary.FILE_DOWNLOAD} sizeInPx='16' color='#555C67'/>
        </button>

        <ReactTooltip id={`download-report-button`} place="top" className="thrive-tooltip no-width" aria-hidden="true" />
        </>
    );
}

export default DownloadReportButton